export const VIEWS = {
  ATHLETE: 'ATHLETE',
  OFFICE: 'OFFICE',
  TEAM: 'OFFICE',
  REGION: 'REGION',
  DIVISION: 'DIVISION',
  CONFERENCE: 'DIVISION',
  COMPANY: 'COMPANY',
};
